module.exports = __webpack_public_path__ + "svg/flags/Tanzania, United Republic of.svg";